@let organizer = organizer$ | async;
@let totalEvents = (totalEvents$ | async) ?? 0;
@let availableEvents = availableList.events();
@let finishedEvents = finishedList.events();
@let cities = (cities$ | async) ?? [];
@let categories = (categories$ | async) ?? [];
@let producerAddress = organizer ? formatAddress(organizer.address) : "";
@let showFinishedEvents = organizer?.past_events ?? false;

<app-layout>
  <app-producers-header
    [organizer]="organizer"
    [numberOfEvents]="totalEvents.toString()"
    [isFollowed]="isFollowed()"
    [isOwnProfile]="isOwnProfile()"
    [isLoggedIn]="isLoggedIn()"
    (followProducerClick)="toggleFollow()"></app-producers-header>

  <main class="producers-page">
    <section class="producers-page__filter">
      <div class="producers-page__filter-container">
        <app-events-filter
          [cities]="cities"
          [categories]="categories"
          [initialFilters]="initialFilters"
          (filtersChange)="handleFiltersChange($event)" />
      </div>
    </section>

    <section class="producers-page__available-events">
      <h1 class="producers-page__title">EVENTOS DISPONÍVEIS</h1>
      <div class="producers-page__events-list producers-page__events-list--available">
        @for (event of availableEvents; track event.id) {
          <app-event-card [event]="event" />
        } @empty {
          @if (!availableList.isLoading()) {
            <p class="producers-page__empty">Nenhum evento encontrado para os filtros selecionados.</p>
          }
        }
        @if (availableList.isLoading() && availableEvents.length === 0) {
          <p-skeleton height="250px" />
          <p-skeleton height="250px" />
          <p-skeleton height="250px" />
          <p-skeleton height="250px" />
        }
      </div>
      @if (availableList.hasMore()) {
        <div class="producers-page__load-more">
          <app-button
            styleType="secondary"
            [rounded]="true"
            [loading]="availableList.isLoading()"
            (btnClick)="loadMoreAvailable()">
            Carregar Mais
          </app-button>
        </div>
      }
    </section>

    @if (showFinishedEvents) {
      <section class="producers-page__finished-events">
        <div class="producers-page__finished-events__container">
          <h1 class="producers-page__title">EVENTOS ENCERRADOS</h1>
          <div class="producers-page__events-list producers-page__events-list--finished">
            @for (event of finishedEvents; track event.id) {
              <app-event-card [event]="event" />
            } @empty {
              @if (!finishedList.isLoading()) {
                <p class="producers-page__empty">Nenhum evento encerrado encontrado.</p>
              }
            }
            @if (finishedList.isLoading() && finishedEvents.length === 0) {
              <p-skeleton height="250px" />
              <p-skeleton height="250px" />
              <p-skeleton height="250px" />
              <p-skeleton height="250px" />
            }
          </div>
        </div>
        @if (finishedList.hasMore()) {
          <div class="producers-page__load-more">
            <app-button
              styleType="secondary"
              [rounded]="true"
              [loading]="finishedList.isLoading()"
              (btnClick)="loadMoreFinished()">
              Carregar Mais
            </app-button>
          </div>
        }
      </section>
    }

    @if (producerAddress) {
      <section class="producers-page__address">
        <h2>{{ producerAddress }}</h2>
      </section>
    }
  </main>
</app-layout>
